import { gql } from "@apollo/client";
import { useQuery } from "@apollo/client/react";

import RevitValues from "./RevitValues.graphql";

export default function useRevitValues() {
    return useQuery(
        gql(RevitValues),
    );
}
